import React from 'react';
import * as PropTypes from 'prop-types';
import InputCheckbox from '../../InputCheckbox';
import InputRadio from '../../InputRadio';

const getControlElementByVariant = ({
  variant,
  isSelected,
  isDisabled,
  labelName,
  controlId,
  value,
}) => {
  switch (variant) {
    case 'radio':
      // TODO: Find a proper solution for using boolean values as options in combination with booleans as IDs
      return (
        <InputRadio
          id={controlId.toString()}
          name={labelName}
          checked={isSelected}
          disabled={isDisabled}
          className="w-4 h-4 cursor-pointer"
          value={value}
          readOnly
        />
      );
    case 'checkbox':
      // TODO: Find a proper solution for using boolean values as options in combination with booleans as IDs
      return (
        <InputCheckbox
          id={controlId.toString()}
          name={labelName}
          checked={isSelected}
          disabled={isDisabled}
          className="cursor-pointer"
          value={value}
          readOnly
        />
      );
    default:
      return null;
  }
};

const OptionCardControl = ({ variant, isSelected, isDisabled, labelName, controlId, value }) => (
  <div className="flex items-center">
    {getControlElementByVariant({ variant, isSelected, isDisabled, labelName, controlId, value })}
  </div>
);

OptionCardControl.propTypes = {
  variant: PropTypes.oneOf(['radio', 'checkbox']).isRequired,
  isSelected: PropTypes.bool,
  isDisabled: PropTypes.bool,
  labelName: PropTypes.string.isRequired,
  controlId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  value: PropTypes.string,
};

OptionCardControl.defaultProps = {
  isSelected: false,
  isDisabled: false,
  value: null,
};

export default OptionCardControl;
